export default __webpack_public_path__ + "static/media/cpv_42_company-machines.9a556afb.svg";